export default {
    actions: {
        getRootSupportCategories(ctx, data) {
            let url = data.path + `/supportCategories?withChildren=yes`;
            if (!!data.catSlug) {
                url = data.path + `/supportCatBySlug/${data.catSlug}?withChildren=yes`;
            }
            axios
                .get(url)
                .then(response => {

                    let categories;

                    if (!(!!data.catSlug)) {
                        categories = response.data.categories;
                    } else {
                        categories = response.data.category.children;
                    }


                    ctx.commit('updateCategories', categories)
                })
        },
        getSupportBySlug(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(data.path + `/supportBySlug/${data.slug}`)
                    .then(response => {
                        resolve(response.data);
                    }).catch(e => {
                    reject(e);
                });
            });
        }
    },
    mutations: {
        updateCategories(state, categories) {
            state.categories = categories;
        }
    },
    state: {
        categories: [],
    },
    getters: {
        allCategories(state) {
            return state.categories
        }
    }
}
